import React from 'react';
import UserBooks from '../components/UserBooks';
import Hero from '../components/Hero';

const HomePage = ({
  user,
  loggedIn,
  userData,
  books,
  fetchBooks,
  fetchUserData,
  showNotification,
  updateCurrentlyReading,
  theme,
  handleThemeChange,
}) => {
  return (
    <div className="container">
      {loggedIn ? (
        <UserBooks
          user={user}
          userData={userData}
          books={books}
          fetchBooks={fetchBooks}
          fetchUserData={fetchUserData}
          showNotification={showNotification}
          updateCurrentlyReading={updateCurrentlyReading}
        />
      ) : (
        <Hero theme={theme} handleThemeChange={handleThemeChange} />
      )}
    </div>
  );
};

export default HomePage;
